/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      // Events are sent manually via window.aa; prevent automatic insights from double-tracking.
      insights: false,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      collection: algolia.getTemplate('instant_search_collection'),
      collections_header: algolia.getTemplate('instant_search_collections_header'),
      collections_footer: algolia.getTemplate('instant_search_collections_footer'),
      pages: algolia.getTemplate('instant_search_page'),
      pages_header: algolia.getTemplate('instant_search_pages_header'),
      articles: algolia.getTemplate('instant_search_article'),
      articles_header: algolia.getTemplate('instant_search_articles_header'),
      stats: algolia.getTemplate('instant_search_stats')/*,
      style: algolia.compileTemplate('instant_search.css'),*/
    },
  };

  if (collectionPageEnabled && window.location.pathname.match(/\/collections\/tuotesuosittelut/i)) {
    instant.templates.product = algolia.getTemplate('instant_search_product_staffreview');
  }

  algolia.instantsearch = instant;

  if (instant.poweredBy) {
    // eslint-disable-next-line no-console
    console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  /*
  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );
  */

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  function refreshStoreAvailability(store) {
    const resultsContainer = instant.$results.matches('.ais-results')
      ? instant.$results
      : instant.$results.querySelector('.ais-results');

    if (!resultsContainer) {
      return;
    }

    if (store) {
      resultsContainer.setAttribute('data-selected-store-name', store.name);
    } else {
      resultsContainer.removeAttribute('data-selected-store-name');
    }

    instant.search.refresh();
  }

  document.addEventListener('theme:store-selected', function(event) {
    refreshStoreAvailability({
      name: event.detail.storeName,
    });
  });

  document.addEventListener('theme:store-cleared', function() {
    refreshStoreAvailability(null);
  });

  // Mobile facets display
  /*
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        $button.addEventListener('click', function() {
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            //$button.textContent = 'Näytä rajaukset';
            $button.innerHTML = '<select><option>Näytä rajaukset</option></select>';
            $facets.classList.remove('ais-facets__shown');
          } else {
            //$button.textContent = 'Piilota rajaukset';
            $button.innerHTML = '<select class="options-open"><option>Piilota rajaukset</option></select>';
            $facets.classList.add('ais-facets__shown');
          }
        });
      },
    },
  ]);*/

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        if (!instant.poweredBy) {
          document.querySelector('.ais-algolia-icon').style.display = 'none';
          document.querySelector('.ais-algolia-icon').setAttribute('aria-hidden', 'true');
          document.querySelector('.ais-algolia-icon').parentElement.style.display = 'none';
          document.querySelector('.ais-algolia-icon').parentElement.setAttribute('aria-hidden', 'true');
        }
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            document.querySelector('.ais-algolia-icon').style.display = '';
          }
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
          document.querySelector('.ais-algolia-icon').style.display = 'none';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document
          .querySelector('.ais-search-header .ais-change-display-block')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
          });
        document
          .querySelector('.ais-search-header .ais-change-display-list')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a tabindex="0" ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-selected-filters">' + algolia.translations.selectedFilter + '</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul id="refinedValuesList" class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var canOrder = function(product) {
    if (!product.requires_shipping) {
      return true;
    }

    if (!product.tags.length) {
      return true;
    }

    let saldoChecked = false;
    for (let i = 0; i < product.tags.length; i++) {
      if (product.tags[i].toLowerCase().indexOf('saldo checked') !== -1) {
        // product is saldo checked (inventory is tracked)
        saldoChecked = true;
        break;
      }
    }

    if (saldoChecked && product.inventory_quantity <= 0) {
      return false;
    }

    return true;
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  // Product hierarchy
  let productLine, mainProductGroup, productGroup;

  // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
      },
      escapeHTML: false,
      transformItems: function(products) {
        const resultsContainer = instant.$results.querySelector('.ais-results');
        const selectedStoreName = resultsContainer
          ? resultsContainer.getAttribute('data-selected-store-name')
          : null;
        // locations_inventory is keyed by store id, so map the selected store
        // name back to its location id using the pickup store metaobjects.
        let storeNameToId = {};
        const storeNameToIdEl = document.getElementById('pickupStoreNameToId');
        if (storeNameToIdEl && storeNameToIdEl.textContent) {
          try {
            storeNameToId = JSON.parse(storeNameToIdEl.textContent);
          } catch (e) {
            storeNameToId = {};
          }
        }
        const selectedStoreIdRaw = selectedStoreName
          ? storeNameToId[selectedStoreName.trim().toLowerCase()]
          : null;
        const selectedStoreId = selectedStoreIdRaw != null
          ? String(selectedStoreIdRaw)
          : null;
        const centralWarehouseInput = document.querySelector('#centralWarehouseLocationID');
        const excludedStoreId = centralWarehouseInput
          ? centralWarehouseInput.value
          : null;
        const selectedPickupStoreId = selectedStoreId === excludedStoreId
          ? null
          : selectedStoreId;
        let excludedPickupStoreIds = [];
        const excludedPickupStoreIdsEl = document.getElementById('excludedPickupStoreIds');
        if (excludedPickupStoreIdsEl && excludedPickupStoreIdsEl.textContent) {
          try {
            excludedPickupStoreIds = JSON.parse(excludedPickupStoreIdsEl.textContent).map(String);
          } catch (e) {
            excludedPickupStoreIds = [];
          }
        }
        let allCollections = [];
        if(document.querySelector('#all-collections-to-json') && document.querySelector('#all-collections-to-json').textContent) {
          allCollections = JSON.parse(document.querySelector('#all-collections-to-json').textContent)
        }

        return products.map(function(product) {
          const availableAtAnyStoreCount = product.locations_inventory
            ? Object.keys(product.locations_inventory).filter(function(storeId) {
              return (
                storeId !== excludedStoreId &&
                excludedPickupStoreIds.indexOf(storeId) === -1 &&
                (!selectedPickupStoreId || storeId !== selectedPickupStoreId) &&
                Number(product.locations_inventory[storeId]) > 0
              );
            }).length
            : 0;
          const productIsDigital = algolia.isDigitalProduct(product);
          let obj = {
            _distinct: instant.distinct,
            can_order: canOrder(product),
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
            selected_store_name: selectedStoreName,
            available_at_selected_store: Boolean(
              !productIsDigital &&
              selectedPickupStoreId &&
              product.locations_inventory &&
              Number(product.locations_inventory[selectedPickupStoreId]) > 0
            ),
            unavailable_at_selected_store: Boolean(
              !productIsDigital &&
              selectedPickupStoreId &&
              product.locations_inventory &&
              (typeof product.locations_inventory[selectedPickupStoreId] === 'undefined' ||
                Number(product.locations_inventory[selectedPickupStoreId]) <= 0)
            ),
            available_at_any_store: !productIsDigital && !selectedPickupStoreId && availableAtAnyStoreCount > 0,
            available_at_any_store_text: algolia.translations.availableAtOtherStores.replace(
              '__STORE_COUNT__',
              availableAtAnyStoreCount
            ),
            shipping_availability_text: algolia.getShippingAvailabilityText(product),
          };

          obj.only_from_us = false;
          obj.only_from_stores = false;
          obj.not_buyable = false;
          obj.is_sk200_product = false;
          obj.lahjakortti_b2b = false;
          obj.loyalty_gold_level_product = false;

          if (product.meta?.woolman?.availability) {
            if (typeof product.meta.woolman.availability === 'string') {
              if (product.meta.woolman.availability.toLowerCase() == 'sk200') {
                obj.is_sk200_product = true;
              }
            }
          }

          if (product.compare_at_price && product.compare_at_price > 0) {
            obj.compare_at_price_in_cents = product.compare_at_price.toString().replace(".","");
          }
          if (product.variants_count > 1) {
            obj.multiple_variants = true;
          } else {
            obj.multiple_variants = false;
          }
          if (product.tags.length > 0 ) {
            product.categories = '';
            for (let i = 0; i < product.tags.length; i++) {
              const tag = product.tags[i];
              if (tag.toLowerCase().indexOf("loyal|") !== -1 && tag.split("|")[1] === product.sku) {
                obj.loyalty_price = tag.split("|")[2].replace(".",",");
                obj.loyalty_price_in_cents = tag.split("|")[2].replace(".","");
              }
              if (tag.toLowerCase().indexOf("loyalty_gold|") !== -1 && tag.split("|")[1] === product.sku) {
                obj.loyalty_price_gold = tag.split("|")[2].replace(".",",");
                obj.loyalty_price_gold_in_cents = tag.split("|")[2].replace(".","");
              }
              if (tag.toLowerCase().indexOf("vain meiltä!") !== -1) {
                obj.only_from_us = true;
              }
              if (tag.toLowerCase().indexOf("saatavilla vain myymälöistä") !== -1) {
                obj.only_from_stores = true;
              }
              if (tag.toLowerCase().indexOf("not buyable") !== -1) {
                obj.not_buyable = true;
              }
              if (tag.toLowerCase().indexOf("lahjakortti-b2b") !== -1) {
                obj.lahjakortti_b2b = true;
              }
              if (tag.toLowerCase().indexOf("kultatason kirjaetu") !== -1) {
                obj.loyalty_gold_level_product = true;
              }
            }
            if (obj.only_from_stores) {
              obj.not_buyable = false;
            }
          }
          if (typeof product.named_tags.Tuotelinja == 'string') {
            productLine = product.named_tags.Tuotelinja.trim().toLowerCase();
          } else if (Array.isArray(product.named_tags.Tuotelinja) && product.named_tags.Tuotelinja.length > 0) {
            productLine = product.named_tags.Tuotelinja[0].trim().toLowerCase();
          }
          if (typeof product.named_tags.Tuotepääryhmä == 'string') {
            mainProductGroup = product.named_tags.Tuotepääryhmä.trim().toLowerCase();
          } else if (Array.isArray(product.named_tags.Tuotepääryhmä) && product.named_tags.Tuotepääryhmä.length > 0) {
            mainProductGroup = product.named_tags.Tuotepääryhmä[0].trim().toLowerCase();
          }
          if (typeof product.named_tags.Tuoteryhmä == 'string') {
            productGroup = product.named_tags.Tuoteryhmä.trim().toLowerCase();
          } else if (Array.isArray(product.named_tags.Tuoteryhmä) && product.named_tags.Tuoteryhmä.length > 0) {
            productGroup = product.named_tags.Tuoteryhmä[0].trim().toLowerCase();
          }
          product.categories = productLine + '/' + mainProductGroup + '/' + productGroup;

          obj.unavailable_at_any_store = false;
          if (!productIsDigital && !selectedPickupStoreId && availableAtAnyStoreCount === 0) {
            let skCode = '';
            if (product.meta?.woolman?.availability && typeof product.meta.woolman.availability === 'string') {
              skCode = product.meta.woolman.availability.toLowerCase();
            }
            if (productLine === 'tavarat') {
              obj.unavailable_at_any_store = true;
            } else if (productLine === 'kirjat' && (skCode === 'sk3' || skCode === 'sk5')) {
              obj.unavailable_at_any_store = true;
            }
          }

          if (allCollections && allCollections.length > 0 && product.collections && product.collections.length > 0) {
            const handlesToMatch = new Set(product.collections);
            const matchingCollections = allCollections.filter(collection => 
              handlesToMatch.has(collection.handle)
            );

            if (matchingCollections && matchingCollections.length > 0) {
              const collectionTitles = matchingCollections.map(collection => collection.title).join(', ');
              product.dimension4 = collectionTitles.length > 100 ? collectionTitles.slice(0, 97) + '...' : collectionTitles;
            } else {
              product.dimension4 = '';
            }
          } else {
            product.dimension4 = '';
          }

          if (product.named_tags.Kokoelma == 'US Edition') {
            obj.edition = "US Edition";
          }
          if (product.named_tags.Kokoelma == 'UK Edition') {
            obj.edition = "UK Edition";
          }

          var staffReviews = [];
          if (product.meta && product.meta.staff_review) {
            for (var key in product.meta.staff_review) {
              if (key.indexOf('review_') === 0) {
                var reviewData = product.meta.staff_review[key];
                // If reviewData is a JSON string, parse it:
                if (typeof reviewData === 'string') {
                  try {
                    reviewData = JSON.parse(reviewData);
                  } catch (e) {
                    reviewData = {};
                  }
                }
                staffReviews.push(reviewData);
              }
            }
          }
          obj.staff_reviews = staffReviews;

          return algolia.assign({}, product, obj);
        });
      },
    }),
  ]);

  // Insert an empty placement slot after the 12th and 18th hit. To allow insertion of a banner or similar.
  // Slots are created only if they don't exist, and existing slots with their content are preserved across renders.
  instant.search.addWidgets([
    {
      render: function() {
        var hitsContainer = document.querySelector('.ais-hits-container');
        var hitsList = hitsContainer
          ? hitsContainer.querySelector('.ais-Hits-list')
          : null;
        if (!hitsList) {
          return;
        }

        var hitItems = hitsList.querySelectorAll('.ais-Hits-item');
        [12, 18].forEach(function(position) {
          if (hitItems.length < position) {
            return;
          }

          var placementId = 'placement-element-after-' + position;
          var existingPlacement = document.getElementById(placementId);
          var targetItem = hitItems[position - 1];

          if (!existingPlacement) {
            // Create new placement only if it doesn't exist
            var placementItem = document.createElement('li');
            placementItem.className = 'ais-hit-placement';
            placementItem.id = placementId;
            placementItem.setAttribute('data-placement-slot', 'after-' + position);
            targetItem.insertAdjacentElement('afterend', placementItem);
          } else if (existingPlacement.previousElementSibling !== targetItem) {
            // If placement exists but is in wrong position, move it to the correct position
            targetItem.insertAdjacentElement('afterend', existingPlacement);
          }
          // Otherwise, placement exists and is in the correct position - leave it alone
        });
      },
    },
  ]);

  
  /* Supplementary hits */
  
  if (!collectionPageEnabled) { // do not run supplementary queries outside of AIS

    function hitsWithPanel(header) {
      return panel({
        hidden(options) {
          return options.results.nbHits === 0
        },
        templates: {
          header
        }
      })(hits)
    }

    // Collections
    instant.search.addWidgets([
      instantsearch.widgets.index({indexName: algolia.config.index_prefix + 'collections'})
        .addWidgets([
          hitsWithPanel(instant.templates.collections_header)({
            container: '.ais-collections',
            escapeHTML: false,
            templates: {
              item: instant.templates.collection
            }
          }),
          configure({
            hitsPerPage: 3,
          }),
        ])
    ]);

    // Pages
    instant.search.addWidgets([
      instantsearch.widgets.index({indexName: algolia.config.index_prefix + 'pages'})
        .addWidgets([
          hitsWithPanel(instant.templates.pages_header)({
            container: '.ais-pages',
            escapeHTML: false,
            templates: {
              item: instant.templates.pages
            }
          }),
          configure({
            hitsPerPage: 3,
          })
        ])
    ]);

    // Articles
    instant.search.addWidgets([
      instantsearch.widgets.index({indexName: algolia.config.index_prefix + 'articles'})
        .addWidgets([
          hitsWithPanel(instant.templates.articles_header)({
            container: '.ais-articles',
            escapeHTML: false,
            templates: {
              item: instant.templates.articles
            },
          }),
          configure({
            hitsPerPage: 3,
          }),
        ])
    ]);
  }

  // Redirect on click
  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart .add-to-cart')) {
              cartButton = el;
              break;
            }
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (cartButton) {
            return;
          }
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = '/collections/' + collectionHandle;
          }

          // Add the product handle to the link
          link = link + '/products/' + productHandle + '?';

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += 'variant=' + variant_id + '&';
          }

          // Add queryID and objectID so they can be easily fetched later
          link += 'queryId=' + hit.dataset.algoliaQueryid + '&' + 'objectId=' + hit.dataset.algoliaObjectid;

          if (algolia.config.analytics_enabled) {
            let token = algolia.getAlgoliaUserToken();
            if (token) {
              /**
               * Set click event data.
               *
               * We override the default userToken saved in
               * _ALGOLIA cookie with custom token here.
               *
               * Note: hit.dataset.algoliaIndex is undefined,
               * so we fetch the index name from Shopify settings.
               */
              var clickData = {
                userToken: token,
                index: 'shopify_test_products',
                eventName: 'click',
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
                positions: [Number(hit.dataset.algoliaPosition)],
              };
              // Send the click event
              window.aa('clickedObjectIDsAfterSearch', clickData);
              // store data in local storage for conversion tracking
              algolia.saveForConversionTracking(clickData);
            }
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        /*
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
        */
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Pagination
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 2,
      maxPages: 20,
    }),
  ]);

  // Main
  instant.search.start();

  // Add event listener to elements with class 'ais-facet--header' to toggle the visibility of the facet options
  let facetHeaders = document.querySelectorAll('.ais-facet--header');
  
  // Function to toggle the visibility of the facet options and set tabindex for accessibility
  function toggleFacetOptions(facetHeader) {
    let facetContainer = facetHeader.parentNode;
    let isShowingOptions = facetContainer.classList.contains('show-options');

    // Close other open elements
    let openFacetContainers = document.querySelectorAll('.ais-facet-container.show-options');
    openFacetContainers.forEach(function (openFacetContainer) {
      if (openFacetContainer !== facetContainer) {
        openFacetContainer.classList.remove('show-options');
        // Set tabindex="-1" for options in closed containers
        let closedOptions = openFacetContainer.querySelectorAll('.ais-facet--label input');
        closedOptions.forEach(function (option) {
          option.setAttribute('tabindex', '-1');
        });
        let closedHandles = openFacetContainer.querySelectorAll('.rheostat-handle');
        closedHandles.forEach(function (handle) {
          handle.setAttribute('tabindex', '-1');
        });
      }
    });

    // Toggle visibility of the clicked element
    if (isShowingOptions) {
      facetContainer.classList.remove('show-options');
      // Set tabindex="-1" for options in the closed container
      let options = facetContainer.querySelectorAll('.ais-facet--label input');
      options.forEach(function (option) {
        option.setAttribute('tabindex', '-1');
      });
      // Set tabindex="-1" for .rheostat-handle elements in the closed container
      let handles = facetContainer.querySelectorAll('.rheostat-handle');
      handles.forEach(function (handle) {
        handle.setAttribute('tabindex', '-1');
      });
    } else {
      facetContainer.classList.add('show-options');
      // Set tabindex="0" for options in the opened container
      let options = facetContainer.querySelectorAll('.ais-facet--label input');
      options.forEach(function (option) {
        option.setAttribute('tabindex', '0');
      });
      // Set tabindex="0" for .rheostat-handle elements in the opened container
      let handles = facetContainer.querySelectorAll('.rheostat-handle');
      handles.forEach(function (handle) {
        handle.setAttribute('tabindex', '0');
      });
    }
  }

  // Add event listeners to facet headers
  facetHeaders.forEach(function (facetHeader) {
    facetHeader.addEventListener('click', function () {
      toggleFacetOptions(facetHeader);
    });

    facetHeader.addEventListener('keydown', function (event) {
      // Add keydown event listener for accessibility
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevent default scroll behavior for space key
        toggleFacetOptions(facetHeader);
      }
    });
  });

  $(document).on('open.zf.reveal', '#filtersModal', function() {
    // Ensure this code runs only once
    if (!window.filtersModalInitialized) {
      window.filtersModalInitialized = true;
      // set tabindex="-1" for all options initially
      let allOptions = document.querySelectorAll('.ais-facet--label input');
      allOptions.forEach(function(option) {
        option.setAttribute('tabindex', '-1');
      });
      // Set tabindex="-1" for elements with class 'rheostat-handle'
      let rheostatHandles = document.querySelectorAll('.rheostat-handle');
      rheostatHandles.forEach(function(handle) {
        handle.setAttribute('tabindex', '-1');
      });
    }

    // Monitor changes to the div with classes 'ais-current-refined-values ais-facet'
    const refinedValuesContainer = document.querySelector('.ais-current-refined-values-container');
    if (refinedValuesContainer) {
      // Create a MutationObserver to watch for changes
      const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
          // Look for all elements with .ais-facet-container
          const facetContainers = document.querySelectorAll('.ais-facet-container');
          facetContainers.forEach(function(facetContainer) {
            // Check if the element does not contain the class .show-options
            if (!facetContainer.classList.contains('show-options')) {
              // Look for children inputs and add tabindex="-1"
              const inputs = facetContainer.querySelectorAll('input');
              inputs.forEach(function(input) {
                input.setAttribute('tabindex', '-1');
              });
              // Look for .rheostat-handle elements and add tabindex="-1"
              const rheostatHandles = facetContainer.querySelectorAll('.rheostat-handle');
              rheostatHandles.forEach(function(handle) {
                handle.setAttribute('tabindex', '-1');
              });
            }
          });
          // Add click event listener to labels to toggle the checkbox
          document.querySelectorAll('.ais-RefinementList-label').forEach(function(label) {
            label.addEventListener('click', function(event) {
              let input = label.querySelector('input[type="checkbox"]');
              if (input) {
                input.click(); // Trigger the click event to toggle the checkbox state
              }
            });
          });
        });
      });

      observer.observe(refinedValuesContainer, {
        childList: true, // Monitor changes to child elements
        subtree: true,   // Monitor changes within the subtree
        attributes: true // Monitor attribute changes
      });
    }

    document.querySelector('#closeFiltersModal').addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        const firstLink = document.querySelector('#refinedValuesList .ais-current-refined-values--link');
        if (firstLink) {
          setTimeout(function() {
            firstLink.focus();
          }, 10);
        }
      }
    });

    // moving back from first .ais-facet-container
    document.querySelector('.ais-facet-container').addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && event.shiftKey) {
        const firstFocusableElement = this.querySelector('input, button, [tabindex="0"]');
        const clearRefinementsButton = document.querySelector('.ais-ClearRefinements-button');
        if (document.activeElement === firstFocusableElement && clearRefinementsButton && !clearRefinementsButton.disabled) {
          event.preventDefault();
          setTimeout(function() {
            clearRefinementsButton.focus();
          }, 10);
        }
      }
    });

    // moving back from last .ais-facet-container
    document.querySelector('.ais-current-refined-values-container').addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && event.shiftKey) {
        const firstFocusableElement = this.querySelector('input, button, [tabindex="0"]');
        const closeFiltersModalButton = document.getElementById('closeFiltersModal');
        if (document.activeElement === firstFocusableElement && closeFiltersModalButton) {
          event.preventDefault();
          closeFiltersModalButton.focus();
        }
      }
    });

    // Function to trigger the click event
    function triggerClickEvent(element) {
      let event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      element.dispatchEvent(event);
    }

    // Add a keydown event listener to the document
    document.addEventListener('keydown', function(event) {
      // Check if the Enter key or Space bar is pressed
      if (event.key === 'Enter' || event.key === ' ') {
        // Get the currently focused element
        let focusedElement = document.activeElement;
        // Check if the focused element is a link inside .ais-current-refined-values--item
        if (focusedElement.tagName === 'A' && focusedElement.closest('.ais-current-refined-values--item')) {
          // Trigger the click event on the focused element
          triggerClickEvent(focusedElement);
          // Prevent default behavior for Space bar to avoid scrolling
          if (event.key === ' ') {
            event.preventDefault();
          }
        }
      }
    });
  });

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
